import { Button, DatePicker, Menu, Space } from "antd";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "assets/icons";
import useCustomRangePicker from "./useCustomRangePicker";
import "./index.scss";

const CustomRangePicker = ({
  value, //ant form item
  onChange, //ant form item
  buttonLabel,
  options = ["today", "custom"],
  defaultOptionKey,
  onConfirm,
  getValue,
  dropdownAlign,
}) => {
  const { t } = useTranslation();
  const {
    isOpen,
    dates,
    renderOptions,
    handleClickButton,
    handleOpenPicker,
    renderRangerPicker,
    onClose,
    onChangeDate,
    onDelete,
    onOke,
  } = useCustomRangePicker({ value, onChange, onConfirm, options, getValue });

  return (
    <div className="custom-range-picker-container">
      <Button onClick={handleClickButton}>
        <FontAwesomeIcon icon={Icon.faFilter} style={{ marginRight: "16px" }} />
        {buttonLabel || t("common.filter")}
      </Button>
      <DatePicker.RangePicker
        style={{ visibility: "hidden", width: 0, padding: 0, margin: 0, height: 0, border: 0 }}
        open={isOpen}
        value={dates}
        // onOpenChange={handleOpenPicker}
        dropdownClassName="menu-select-range-picker"
        dropdownAlign={dropdownAlign || { offset: [0, 0] }}
        onChange={onChangeDate}
        panelRender={(originalPanel) => {
          return (
            <>
              <Menu mode="inline" defaultSelectedKeys={defaultOptionKey}>
                {renderOptions}
              </Menu>
              <Space>
                {originalPanel}
                <div className="buttons">
                  {renderRangerPicker()}
                  <Button onClick={onClose}>{t("common.close")}</Button>
                  <Button onClick={onDelete}>{t("common.delete")}</Button>
                  <Button onClick={onOke} type="primary">
                    {t("common.confirm")}
                  </Button>
                </div>
              </Space>
            </>
          );
        }}
      />
    </div>
  );
};

export default CustomRangePicker;
